
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_41252_228753)"}},[_c('path',{attrs:{"d":"M10 1.667a8.335 8.335 0 000 16.667A8.333 8.333 0 0018.332 10c0-4.6-3.732-8.333-8.334-8.333zm0 3.696a1.411 1.411 0 110 2.823 1.411 1.411 0 010-2.823zm1.881 8.535c0 .223-.18.403-.403.403H8.52a.403.403 0 01-.403-.403v-.806c0-.223.18-.404.403-.404h.403v-2.15h-.403a.403.403 0 01-.403-.403v-.807c0-.222.18-.403.403-.403h2.15c.223 0 .404.18.404.403v3.36h.403c.223 0 .403.181.403.404v.806z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_41252_228753"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1.666 1.667)","d":"M0 0h16.667v16.667H0z"}})])])])
          )
        }
      }
    